import { api, qs } from "./base";
import type { FeedbackRow, ListResponse, PrRow } from "@/common/types";

/** PRs for a repo (and/or by status), or global by status. */
export function listPrs(params: {
  repo?: string;
  status?: string;
}): Promise<ListResponse<PrRow>> {
  return api.get<ListResponse<PrRow>>(`/prs${qs(params)}`);
}

export function getPr(prUrl: string): Promise<PrRow> {
  return api.get<PrRow>(`/prs/detail${qs({ prUrl })}`);
}

// -- feedback (M4 Phase 2 — learning-loop input) --

/** All feedback for one PR (by subject), newest-first. */
export function listPrFeedback(
  prUrl: string,
): Promise<ListResponse<FeedbackRow>> {
  return api.get<ListResponse<FeedbackRow>>(
    `/feedback${qs({ subjectId: prUrl })}`,
  );
}

/** Submit engineer feedback on a fix PR. outcome ∈ MERGED|DECLINED|CHANGES_REQUESTED. */
export function submitPrFeedback(
  prUrl: string,
  repo: string,
  actor: string,
  outcome: string,
  comment: string,
) {
  return api.post(`/prs/feedback${qs({ prUrl })}`, {
    repo,
    outcome,
    comment,
    actor,
  });
}
